document.querySelectorAll('.product-bsb__media').forEach(function (media) {
  var mainImg = media.querySelector('[data-product-bsb-main-image]');
  var thumbs = Array.prototype.slice.call(media.querySelectorAll('[data-product-bsb-thumb]'));
  if (!mainImg || !thumbs.length) return;
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var fullSrc = thumb.getAttribute('data-full-src');
      if (!fullSrc) return;
      mainImg.src = fullSrc;
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });
});
